import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, ButtonWithIcon } from '@els/els-react--button';
import { Banner } from '@els/els-react--banner';

function ResetPasswordWithTokenDialogError({ openForgotPasswordDialog, errorDetails }) {
  const [showDetails, setShowDetails] = useState(false);

  const getFormattedTimestamp = () => {
    const isoString = new Date().toISOString();
    const replaced = isoString.replace('T', ' ');
    const parts = replaced.split('.');
    return parts[0] || replaced;
  };

  return (
    <div className="reset-password-with-token-dialog__error">
      <Banner isVisible type="warn" className="reset-password-with-token-dialog__error-banner">
        Your password reset link has expired. Please try again.
      </Banner>

      <div className="reset-password-with-token-dialog__error-details">
        <ButtonWithIcon
          type="link"
          sprite={showDetails ? 'ChevronUp' : 'ChevronDown'}
          size="small"
          data-e2e="reset-password-error-details-toggle"
          onClick={() => setShowDetails(!showDetails)}
          className="u-els-color-text">
          Show error details
        </ButtonWithIcon>
        {showDetails && errorDetails && (
          <div className="reset-password-with-token-dialog__error-details-content u-els-margin-top-1o2">
            <div className="u-els-margin-bottom-1o2">{getFormattedTimestamp()}</div>
            <div className="u-els-margin-bottom-1o4">Reference:</div>
            <div className="reset-password-with-token-dialog__error-reference">{errorDetails}</div>
          </div>
        )}
      </div>

      <div className="reset-password-with-token-dialog__error-separator" />

      <div className="reset-password-with-token-dialog__error-recovery">
        <p className="u-els-margin-bottom-1o2">Get another link in your email</p>
        <Button
          type="link"
          size="default"
          data-e2e="reset-password-recovery-link"
          onClick={openForgotPasswordDialog}
          className="u-els-color-link-inline">
          Password recovery
        </Button>
      </div>
    </div>
  );
}

ResetPasswordWithTokenDialogError.propTypes = {
  openForgotPasswordDialog: PropTypes.func.isRequired,
  errorDetails: PropTypes.string,
};

export default ResetPasswordWithTokenDialogError;
